import "./FrequentlyAskedQuestions.module.css";
import Header from "@/reusable_sections/Header";
import ServiceAvailabilityFAQ from "./sections/ServiceAvailabilityFAQ";
import CourtProcessFaq from "./sections/CourtProcessFaq";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function FrequentlyAskedQuestionsPage() {
  return <div>
      <Header />
      <ServiceAvailabilityFAQ />
      <CourtProcessFaq />
      <Inquiries />
      <Footer />
    </div>;
}